import { globalLoader } from '@/helpers/variables/index';
import { $http } from '@/utils/https'
import {
    SET_USER_DATA,
    LOADING_USER_DATA,
    UPDATE_USER_DATA_LOADING,
    SHOW_POPUP_UPDATE_PASSWORD,
    UPDATE_USER_PASSWORD_LOADING,
    FAVORITES_FRESH_LIST
} from '../mutation-types';

import {
    FETCH_USER_DATA, SING_IN_WITH_FACEBOOK, SING_IN_WITH_GOGGLE,
    UPDATE_USER_DATA,
    UPDATE_USER_PASSWORD,
    LINK_WITH_GOOGLE,
    LINK_WITH_FACEBOOK,
    UNLINK_WITH_GOOGLE,
    UNLINK_WITH_FACEBOOK
} from '../action-types';


const state = {
    user: null,
    loadingUser: false,
    updateUserLoading: false,
    showPopupUpdatePassword: false,
    updatePasswordLoading: false,
};

const getters = {
    updatePasswordLoading: state => state.updatePasswordLoading,
    showPopupUpdatePassword: state => state.showPopupUpdatePassword,
    user: state => state.user,
    loadingUser: state => state.loadingUser,
    updateUserLoading: state => state.updateUserLoading,
};

const actions = {
    [FETCH_USER_DATA]: async ({ commit }) => {
        try {
            commit(LOADING_USER_DATA, true);

            const response = await $http.get('v1/me');
            commit(SET_USER_DATA, response.data.data);
            commit(`favorites/${FAVORITES_FRESH_LIST}`, response.data.data.favorites.data, { root: true })
            return response;
        }catch (e) {
            throw e;
        }finally {
            commit(LOADING_USER_DATA, false);
        }
    },
    [UPDATE_USER_DATA]: async ({ commit }, payload) => {
        try {
            commit(UPDATE_USER_DATA_LOADING, true);
            const response = await $http.post('v1/users/update', payload);
            commit(SET_USER_DATA, response.data.data);
            return response;
        }catch (e) {
            throw e;
        }finally {
            commit(UPDATE_USER_DATA_LOADING, false);
        }
    },
    [UPDATE_USER_PASSWORD]: async ({ commit }, payload) => {
        try {
            commit(UPDATE_USER_PASSWORD_LOADING, true);
            const response = await $http.post('v1/users/change_password', payload);
            return response;
        }catch (e) {
            throw e;
        }finally {
            commit(UPDATE_USER_PASSWORD_LOADING, false);
        }
    },
    [LINK_WITH_GOOGLE]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/google/link', payload);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [LINK_WITH_FACEBOOK]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/facebook/link', payload);
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [UNLINK_WITH_GOOGLE]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/google/unlink');
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
    [UNLINK_WITH_FACEBOOK]: async ({commit}, payload) => {
        globalLoader(true);
        try {
            const result = await $http.post('v1/oauth/facebook/unlink');
        } catch (e) {
            throw e;
        } finally {
            globalLoader(false);
        }
    },
};

const mutations = {
    [SET_USER_DATA](state, data) {
        state.user = data;
    },
    [LOADING_USER_DATA](state, status) {
        state.loadingUser = status;
    },
    [UPDATE_USER_DATA_LOADING](state, status) {
        state.updateUserLoading = status;
    },
    [SHOW_POPUP_UPDATE_PASSWORD](state, status) {
        state.showPopupUpdatePassword = status;
    },
    [UPDATE_USER_PASSWORD_LOADING](state, status) {
        state.updatePasswordLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
